import { FC, ReactNode } from "react"
import { useTranslation } from "react-i18next"

import { ISummarySection } from "@/types"
import { IListItem } from "components/List/List"
import Summary from "components/Summary/Summary"
import useAssetFields, { AssetField } from "hooks/useAssetFields"
import { AssetStep } from "pages/AssetPage/config"
import useAssetSummaryTechnicalData from "hooks/useAssetSummaryTechnicalData"
import Color from "models/Color"
import useAssetTechnicalDataFields from "hooks/useAssetTechnicalDataFields"
import { useAssetDataContext } from "./AssetDataContext"

interface IAssetDataTechnicalDataProps {
    operationHoursLogButton: ReactNode
    color: Color | null
}

const AssetDataTechnicalData: FC<IAssetDataTechnicalDataProps> = ({
    operationHoursLogButton,
    color,
}) => {
    const { t } = useTranslation()
    const { asset, article, pinnable, getEditLink, onEditClick } = useAssetDataContext()
    const { getFields } = useAssetFields({ asset, article, operationHoursLogButton, color, pinnable })
    const { getFields: getTechnicalDataFields } = useAssetTechnicalDataFields({ asset, article, color, pinnable })

    const technicalDataItems = useAssetSummaryTechnicalData({
        asset,
        article,
        getFields: getTechnicalDataFields,
    })

    const summaryData: ISummarySection<IListItem>[] = [
        {
            title: t('asset.technicalData'),
            items: [
                ...getFields([
                    AssetField.constructionYear,
                    AssetField.operatingHours,
                    AssetField.operationalState,
                    AssetField.condition,
                ]),
                ...technicalDataItems,
            ],
            editLink: getEditLink?.(AssetStep.technicalData),
            onEditClick: onEditClick ? () => onEditClick(AssetStep.technicalData) : undefined,
        }
    ]


    return (
        <Summary data={summaryData} />
    )
}

export default AssetDataTechnicalData
